import CustomModal from '@/components/common/CustomModal';
import LoginAuto from '@/components/common/LoginAuto';
import Redirect from '@/components/common/Redirect';
import ScrollToTop from '@/components/common/ScrollToTop';
import PlaceDetailModal from '@/components/Home/PlaceDetailModal';
import ReceiptPreviewModal from '@/components/Home/ReceiptPreviewModal';
import GuideModal from '@/components/UploadImage/GuideModal';
import ImagePreviewModal from '@/components/UploadImage/ImagePreviewModal';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import Airport from '@/pages/Airport';
import AirportGuide from '@/pages/AirportGuide';
import AirportLocation from '@/pages/AirportLocation';
import AirportPrintReceipt from '@/pages/AirportPrintReceipt';
import AirportReceipt from '@/pages/AirportReceipt';
import CustomerRefund from '@/pages/CustomerRefund';
import Departure from '@/pages/Departure';
import Home from '@/pages/Home';
import NotFound from '@/pages/NotFound';
import PassportValidate from '@/pages/PassportValidate';
import ReceiptInquiry from '@/pages/ReceiptInquiry';
import PassportRedirect from '@/pages/Redirect';
import RefundInfo from '@/pages/RefundInfo';
import RefundInfoLeaflet from '@/pages/RefundInfoLeaflet';
import RefundProcedure from '@/pages/RefundProcedure';
import RefundResult from '@/pages/RefundResult';
import VerifiactionRedirect from '@/pages/VerificationRedirect';
import { IGlobalState } from '@/store';
import { BankCallGuideModal, CashPickupGuideModal } from '@repo/components';
import { BANK_CALL_GUIDE_MODAL, CASH_PICKUP_NATIONS } from '@repo/constants';
import { isNationIncluded, Iso639_1Code } from '@repo/utils';
import { useEffect } from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import styled from 'styled-components';
import Layout from './components/common/Layout';
import LocationPrintModal from './components/LocationPrint/PlaceDetailModal';
import { routes } from './constants/routes.const';
import AirportNonRefundable from './pages/AirportNonRefundable';
import CashPickupIntro from './pages/CashPickupIntro';
import EmailPage from './pages/Inquiry/Email.page';
import FaqPage from './pages/Inquiry/Faq.page';
import PassportPage from './pages/Inquiry/Passport.page';
import QnaPage from './pages/Inquiry/Qna.page';
import LocationCustoms from './pages/LocationCustoms';
import LocationPrint from './pages/LocationPrint';
import Receipt from './pages/Receipt';
import UploadReceipt from './pages/ReceiptKor';
import SelectAirport from './pages/SelectAirport';
import DepartureCheckPage from './pages/DepartureCheck';
import LocationCustomsCruise from './pages/LocationCustoms/Cruise';
import LocationPrintCruise from './pages/LocationPrint/Cruise';

function RouterContainer() {
  const { nationality, globalModalInfo } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const selectElement = document.querySelector('.goog-te-combo');
  const dispatch = useAppDispatch();

  function changeGoogleTranslateLanguage(nationality: string | null) {
    const nation = Iso639_1Code(nationality);
    if (!nation) return;
    //@ts-ignore
    selectElement.value = nation;
    //@ts-ignore
    selectElement.dispatchEvent(new Event('change'));
  }

  useEffect(() => {
    selectElement && changeGoogleTranslateLanguage(nationality);
  }, [selectElement, nationality]);

  const onCloseModal = () => {
    dispatch({
      type: 'UPDATE_HOME_MODAL_STATE',
      payload: { isActive: false, data: null, type: null },
    });
  };

  return (
    <Container>
      <Translation id='google_translate_element'></Translation>
      <Router>
        <Redirect />
        <LoginAuto />
        <ScrollToTop />
        <Switch>
          <Layout>
            <Route path={routes.passport} component={PassportValidate} exact />
            <Route
              path='/email-verification/:id/:verifiedEmail'
              component={VerifiactionRedirect}
            />
            <Route
              path='/redirect/:passportNumber'
              component={PassportRedirect}
            />
            <Route path={routes.departure} component={Departure} />
            <Route
              path={routes.departureCheck}
              component={DepartureCheckPage}
            />
            <Route path={routes.home} component={Home} />
            <Route path={routes.receipt} component={Receipt} />
            <Route path={routes.uploadReceipt} component={UploadReceipt} />
            <Route path={routes.airport} component={Airport} />
            <Route path={routes.selectAirport} component={SelectAirport} />
            <Route
              path={routes.airportNonRefundable}
              component={AirportNonRefundable}
            />
            <Route path={routes.airportGuide} component={AirportGuide} />
            <Route path={routes.airportLocation} component={AirportLocation} />
            <Route path={routes.airportReceipt} component={AirportReceipt} />
            <Route
              path={routes.airportPrintReceipt}
              component={AirportPrintReceipt}
            />
            <Route path={routes.receiptInquiry} component={ReceiptInquiry} />
            <Route path={routes.customerRefund} component={CustomerRefund} />
            <Route path={routes.refundResult} component={RefundResult} />
            <Route path={routes.refundProcedure} component={RefundProcedure} />
            <Route path={routes.refundInfo} component={RefundInfo} />
            <Route path={routes.locationPrint} component={LocationPrint} />
            <Route
              path={routes.locationPrintCruise}
              component={LocationPrintCruise}
            />
            <Route path={routes.locationCustoms} component={LocationCustoms} />
            <Route
              path={routes.locationCustomsCruise}
              component={LocationCustomsCruise}
            />
            <Route
              path={routes.refundInfoLeaflet}
              component={RefundInfoLeaflet}
            />
            <Route path={routes.inquiryFaq} component={FaqPage} />
            <Route path={routes.inquiryPassport} component={PassportPage} />
            <Route path={routes.inquiryEmail} component={EmailPage} />
            <Route path={routes.inquiryQna} component={QnaPage} />
            <Route path={routes.cashPickupIntro} component={CashPickupIntro} />
          </Layout>
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </Router>
      {/* 커스텀 모달 */}
      {globalModalInfo?.type === 'UPLOAD_IMAGE' &&
        globalModalInfo?.isActive && <GuideModal {...globalModalInfo?.data} />}
      {globalModalInfo?.type === 'PREVIEW_IMAGE' &&
        globalModalInfo?.isActive && (
          <ImagePreviewModal {...globalModalInfo?.data} />
        )}
      {globalModalInfo?.type === 'LOCATION' && globalModalInfo?.isActive && (
        <PlaceDetailModal {...globalModalInfo?.data} />
      )}
      {globalModalInfo?.type === 'LOCATION_PRINT' &&
        globalModalInfo?.isActive && (
          <LocationPrintModal {...globalModalInfo?.data} />
        )}
      {globalModalInfo?.type === 'CUSTOM' && globalModalInfo?.isActive && (
        <CustomModal onClose={onCloseModal} {...globalModalInfo?.data} />
      )}
      {globalModalInfo?.type === 'PREVIEW_RECEIPT' &&
        globalModalInfo?.isActive && (
          <ReceiptPreviewModal {...globalModalInfo?.data} />
        )}
      {isNationIncluded(CASH_PICKUP_NATIONS, nationality) &&
        globalModalInfo?.type === 'CASH_PICKUP_GUIDE' && (
          <CashPickupGuideModal
            isOpen={globalModalInfo?.type === 'CASH_PICKUP_GUIDE'}
            onClose={onCloseModal}
          />
        )}
      {(nationality === 'CHN' || nationality === 'JPN') && (
        <BankCallGuideModal
          isOpen={globalModalInfo?.type === 'BANK_INQUIRY_GUIDE'}
          title={BANK_CALL_GUIDE_MODAL[nationality].title}
          questionTitle={BANK_CALL_GUIDE_MODAL[nationality].questionTitle}
          questionText={BANK_CALL_GUIDE_MODAL[nationality].questionText}
          answerTitle={BANK_CALL_GUIDE_MODAL[nationality].answerTitle}
          answerText={BANK_CALL_GUIDE_MODAL[nationality].answerText}
          btnTitle={BANK_CALL_GUIDE_MODAL[nationality].btnTitle}
          onClick={onCloseModal}
        />
      )}
    </Container>
  );
}
export default RouterContainer;

const Container = styled.div`
  position: static;
`;

const Translation = styled.div`
  position: fixed;
  z-index: 200;
  @media ${(props) => props.theme.desktop} {
    right: 42%;
    top: 2px;
  }
  @media ${(props) => props.theme.mobile} {
    top: 0px;
    right: 20px;
  }
`;

const InfoTitle = styled.span`
  display: block;
  font-weight: 600;
  line-height: 150%;
`;
